import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { UserDemographics, CryptoUsage, UserNotes, OtherApplications, UserWallets } from "./UserSubsections";


// Api Calls
import MissionUserListAPI from "../../../api/api_calls/MissionUserListsAPI";


function AboutUserCard(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, otherId } = useParams()
    const mission_user_list_id = props.mission_user_list_id
    const [user, setUser] = useState({});
    const [userDemographics, setUserDemographics] = useState({});
    const [cryptoUsage, setCryptoUsage] = useState({});
    const [userNote, setUserNote] = useState({});
    const [otherApplications, setOtherApplications] = useState({});
    const [isGuestUser, setIsGuestUser] = useState(false);
    const [guestUserName, setGuestUserName] = useState("");
    const [userWallets, setUserWallets] = useState(null);
    const [loading, setLoading] = useState(true);




    useEffect(() => {
        async function getUserInfo() {
            const result = await MissionUserListAPI.show_user({ missionId, mission_user_list_id, handleRedirect: navigate });

            if (result.success) {
                setUser(result.user)
                setUserDemographics(result.user_demographics)
                setCryptoUsage(result.crypto_usage)
                setUserNote(result.user_note)
                setOtherApplications(result.other_applications)
                setUserWallets(result.user_wallets)
                setIsGuestUser(result.is_guest_user)
                setGuestUserName(result.guest_user_name)
                setLoading(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getUserInfo();
    }, []);

    function updateUserNote(note) {
        setUserNote(note)
    }


    return (
        <Card >
            <GrayCardTitle title={"About " + user.first_name} />
            {loading ? <CenteredLoadingIcon /> :
                isGuestUser ?
                    <div className="about-user-wrap-div">
                        <div className="guest-user-text"> This user is a temporary user from a Your Community project. We don't collect demographic information for these users.</div>
                    </div>
                    :
                    <div className="about-user-wrap-div">
                        <UserDemographics userDemographics={userDemographics} firstName={user.first_name} />
                        <CryptoUsage cryptoUsage={cryptoUsage} />
                        <div className="user-wallets-and-notes-container">
                            {userWallets && <UserWallets userWallets={userWallets} />}
                            <UserNotes userNote={userNote} user={user} setUserNote={updateUserNote} />
                        </div>
                        <OtherApplications otherApplications={otherApplications} />
                    </div>
            }
        </Card>
    )
}



export default AboutUserCard;